import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { authUser } from "../services/login";
import Context from "../context/UserContext";

export default function Login() {
  const { login } = useContext(Context);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [formulario, setFormulario] = useState({ user: "", pass: "" });
  const navigate = useNavigate();

  const handleSubmitForm = () => {
    setLoading(true);
    authUser(formulario).then((res) => {
      if (res.success) {
        login(res.nombre);
        setError("");
        navigate("/home");
      } else {
        setError(res.message);
      }
      setLoading(false);
    });
  };

  const handleChangeForm = (event) => {
    const { name, value } = event.target;
    setFormulario((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="login-bg">
      <div className="relative z-10 w-full max-w-md mx-4">
        <div className="bg-white/90 backdrop-blur-md rounded-2xl shadow-card-lg border border-white/20 p-8">
          <div className="text-center mb-8">
            <img
              src="logo-pons.png"
              alt="PONS RAZAS"
              className="mx-auto h-16 mb-4"
            />
            <h1 className="text-2xl font-bold text-ink">Inicio de Sesion</h1>
            <p className="text-ink-muted text-sm mt-1">Ingresa tus credenciales</p>
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="space-y-5">
            <div>
              <label className="label-field">Nombre de Usuario</label>
              <input
                type="text"
                className="input-field"
                name="user"
                placeholder="Tu usuario"
                onChange={handleChangeForm}
                value={formulario.user}
              />
            </div>

            <div>
              <label className="label-field">Contrasena</label>
              <input
                type="password"
                className="input-field"
                name="pass"
                placeholder="Tu contrasena"
                onChange={handleChangeForm}
                value={formulario.pass}
              />
            </div>

            <button
              type="button"
              className="btn-primary w-full flex items-center justify-center gap-2"
              onClick={handleSubmitForm}
              disabled={loading}
            >
              {loading ? (
                <>
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg>
                  Cargando...
                </>
              ) : (
                "Iniciar Sesion"
              )}
            </button>

            {error && (
              <div className="bg-danger/10 border border-danger/30 text-danger text-sm rounded-xl p-3 text-center">
                {error}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
